import { createContext } from 'react';
import {
	IFirmwareForAssign,
	TFirmwareType,
	IDataGetRestaurantsByIDsCustomersForFirmware,
	IDataGetFirmwareByIDsRestaurantsForFirmware,
	IDataGetCustomersForAssignFirmware,
} from 'types';

export type TIDSelectedTypeFirmware = null | TFirmwareType;
export type TActiveItemToDisplay = 'customers' | 'restaurants' | 'firmware';
export type TTypeOfModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSendChanges'
	| 'success'
	| 'error'
	| 'firmwareLimit'
	| 'firmwareOfSameType'
	| 'restaurantAlreadyHasFirmwareTypeMAX'
	| 'restaurantAlreadyHasFirmwareTypeAndroid';
export interface IIDsSelectedItems {
	[key: string]: boolean; // key - is the ID and boolean means open or closed tab status.
}
export interface IFirmwareWithAdditionalProperty extends IDataGetFirmwareByIDsRestaurantsForFirmware {
	isChanged: boolean;
}
export type TCountOfItems = '12' | '24' | '48';

export interface IFirmwareAssignmentState {
	firmwareForAssign: IFirmwareForAssign;
	searchString: string;
	searchStringForAllCustomers: string;
	searchStringForRestaurants: string;
	searchStringForFirmwares: string;
	IDSelectedTypeFirmware: TIDSelectedTypeFirmware;
	isUnassignedFirmware: boolean;
	IDsSelectedFirmware: string[];
	activeItemToDisplay: TActiveItemToDisplay;
	isShowBreadcrumbs: boolean;
	allCustomers: IDataGetCustomersForAssignFirmware[];
	IDsSelectedCustomers: IIDsSelectedItems;
	restaurants: IDataGetRestaurantsByIDsCustomersForFirmware[];
	IDsSelectedRestaurants: IIDsSelectedItems;
	firmwares: IFirmwareWithAdditionalProperty[];
	typeOfModalWindow: TTypeOfModalWindow;
	currentPage: number;
	countOfItems: TCountOfItems;
}

export const firmwareAssignmentInitialState: IFirmwareAssignmentState = {
	firmwareForAssign: { count: 0, items: [] },
	searchString: '',
	searchStringForAllCustomers: '',
	searchStringForRestaurants: '',
	searchStringForFirmwares: '',
	IDSelectedTypeFirmware: null,
	isUnassignedFirmware: false,
	IDsSelectedFirmware: [],
	activeItemToDisplay: 'customers',
	isShowBreadcrumbs: false,
	allCustomers: [],
	IDsSelectedCustomers: {},
	restaurants: [],
	IDsSelectedRestaurants: {},
	firmwares: [],
	typeOfModalWindow: null,
	currentPage: 1,
	countOfItems: '12',
};

export interface IFirmwareAssignmentContext extends IFirmwareAssignmentState {
	changeSearchString(value: string): void;
	changeSearchStringForAllCustomers(value: string): void;
	changeSearchStringForRestaurants(value: string): void;
	changeSearchStringForFirmwares(value: string): void;
	changeTypeFirmware(value: TIDSelectedTypeFirmware): void;
	resetSelectedControls(): void;
	changeIsUnassignedFirmwareStatus(value: boolean): void;
	setIDsSelectedFirmware(value: string[]): void;
	changeActiveItemToDisplay(value: TActiveItemToDisplay): void;
	setShowBreadcrumbs(value?: boolean): void;
	setIDsSelectedCustomers(value: IIDsSelectedItems, isUpdateRestaurantsList: boolean): Promise<void>;
	setIDsSelectedRestaurants(value: IIDsSelectedItems, isUpdateFirmwaresList: boolean): Promise<void>;
	addSelectedFirmwareToRestaurant(): void;
	deleteFirmwareFromRestaurant(restaurantID: string, firmwareID: string): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	changeCurrentPage(page: number): void;
	resetChanges(): void;
	sendChanges(): Promise<void>;
	updateModuleDataAfterSaving(): void;
}

export const FirmwareAssignmentContext = createContext<IFirmwareAssignmentContext>({
	changeSearchString: () => undefined,
	changeSearchStringForAllCustomers: () => undefined,
	changeSearchStringForRestaurants: () => undefined,
	changeSearchStringForFirmwares: () => undefined,
	changeTypeFirmware: () => undefined,
	resetSelectedControls: () => undefined,
	changeIsUnassignedFirmwareStatus: () => undefined,
	setIDsSelectedFirmware: () => undefined,
	changeActiveItemToDisplay: () => undefined,
	setShowBreadcrumbs: () => undefined,
	setIDsSelectedCustomers: async () => undefined,
	setIDsSelectedRestaurants: async () => undefined,
	addSelectedFirmwareToRestaurant: () => undefined,
	deleteFirmwareFromRestaurant: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	changeCurrentPage: () => undefined,
	resetChanges: () => undefined,
	sendChanges: async () => undefined,
	updateModuleDataAfterSaving: () => undefined,
	...firmwareAssignmentInitialState,
});
